var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 57,
    viewBox: "0 0 158 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7201 1.60587C95.5956 0.683338 109.946 -0.155353 122.83 2.16192C137.658 4.82895 155.754 8.68311 157.859 15.3004C160.013 22.0703 136.808 25.7211 132.421 32.3047C127.641 39.477 144.488 48.6999 132.021 54.0733C120.136 59.1962 98.5017 55.6908 81.7201 54.1581C67.9719 52.9024 57.7219 48.9377 45.3573 46.1579C30.4427 42.8048 8.33785 42.6931 1.88793 36.2101C-4.5158 29.7735 6.66825 22.4849 16.0542 16.7045C23.7734 11.9505 37.113 9.84096 49.2276 7.05545C59.6965 4.64833 69.888 2.39255 81.7201 1.60587Z",
    fill: "#FCEE21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobBg);
export default __webpack_public_path__ + "static/media/Blob-bg.6309aecadf50092fa47f4408292549f9.svg";
export { ForwardRef as ReactComponent };